angular.module('tf.directives')

.directive("resizer",['$document',function($document){
        return {
            restrict: "A",
            link : function($scope, $element, $attrs){
                $element.on('mousedown', function(event) {
                    event.preventDefault();

                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                });

                function mousemove(event) {

                    if ($attrs.resizer == 'vertical') {
                        // Handle vertical resizer
                        var x = event.pageX;

                        if ($attrs.resizerMax && x > $attrs.resizerMax) {
                            x = parseInt($attrs.resizerMax);
                        }

                        $element.css({
                            left: x + 'px'
                        });

                        angular.element(this.querySelector($attrs.resizerLeft)).css({
                            width: x + 'px'
                        });
                        angular.element(this.querySelector($attrs.resizerRight)).css({
                            left: (x + $element[0].clientWidth) + 'px'
                        });

                    } else {
                        // Handle horizontal resizer
                        var y = window.innerHeight - event.pageY;

                        $element.css({
                            bottom: y + 'px'
                        });

                        angular.element(this.querySelector($attrs.resizerTop)).css({
                            bottom: (y + $element[0].offsetHeight) + 'px'
                        });
                        angular.element(this.querySelector($attrs.resizerBottom)).css({
                            height: y + 'px'
                        });
                    }
                }

                function mouseup() {
                    $document.unbind('mousemove', mousemove);
                    $document.unbind('mouseup', mouseup);
                }
            }


        };

    }]);
